import React, { useState } from "react";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "./App.css";

function App() {
  const [pdfFile, setPdfFile] = useState(null);

  // Handle file input for PDF
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type === "application/pdf") {
      const fileURL = URL.createObjectURL(file);
      setPdfFile(fileURL);
    } else {
      alert("Please upload a valid PDF file.");
    }
  };

  return (
    <div className="App">
      <h1>Online PDF Editor</h1>
      <div className="upload-container">
        <input type="file" accept="application/pdf" onChange={handleFileChange} />
      </div> 

      <div className="pdf-viewer">
        {pdfFile ? (
          <Worker
            workerUrl={`https://unpkg.com/pdfjs-dist@3.12.0/build/pdf.worker.min.js`}
          >
            <Viewer fileUrl={pdfFile} />
          </Worker>
        ) : (
          <p>No PDF selected. Please upload a PDF file.</p>
        )}
      </div>
    </div>
  );
}

export default App;
